// @vendors
import { useContext, useEffect, useState } from "react";
import { Button, Divider, Tooltip } from "antd";
// @styles
import "../fields/plans/styles.scss";
import { formatPrice } from "utils/utils";

export default function Modalities({
  modalities,
  showDetail,
  onNext,
  coverages,
}) {
  return modalities.map((modalitie) => (
    <div className="plans__item">
      <div
        className={`plans__item-recommendation ${
          modalitie.recommended && "plans__item-recommendation-active"
        }`}
      >
        Recomendado
      </div>
      <div className="plans__item-header">
        <div className="plans__item-title">{modalitie.modality}</div>
        <div className="plans__item-price">{formatPrice(modalitie.value)}</div>
        <div className="plans__item-resume">{modalitie.description}</div>
        <div className="plans__item-actions">
          <Button
            className="ant-btn-solid c-3"
            onClick={() => onNext(modalitie)}
            data-testid="btn-next"
          >
            Seleccionar
          </Button>
        </div>
      </div>
      {showDetail && (
        <div className="plans__item-extra">
          <Divider></Divider>
          {modalitie.benefits.map((benefit) => (
            <div className="plans__item-extra-item">
              <div className="plans__item-extra-description">{benefit}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  ));
}
